import BottomDrawer from 'src/components/Drawers/BaseDrawers/BottomDrawer/BottomDrawer';
import { cj } from 'src/utils/classNames';
import { WithChildren } from 'src/utils/UtilityTypes';
import { USER_SURVEY_TITLE_CLASSNAME } from 'src/components/UserSurvey/consts';

interface Props extends WithChildren {
	title: string;
	onClose: () => void;
	isClosing: boolean;
}

export default function UserSurveyDrawer({
	title,
	onClose,
	isClosing,
	children,
}: Props) {
	return (
		<BottomDrawer.Container
			closeDrawer={onClose}
			isDrawerClosing={isClosing}
			disableCloseOnOverlayClick
		>
			<BottomDrawer.Title
				closeDrawer={onClose}
				innerWrapperClassName={cj('border-b-0', USER_SURVEY_TITLE_CLASSNAME)}
			>
				{title}
			</BottomDrawer.Title>

			<BottomDrawer.Body className="pt-0">{children}</BottomDrawer.Body>
		</BottomDrawer.Container>
	);
}
